import { useRecoilValue } from "recoil";

import { accountState } from "../../../../recoil/account/accountStateV2";

import MyProfile from "./MyProfile";
import Billing from "./Billing";

import styles from "./Account.module.css";

interface AccountProps {
  onDelete: () => void;
}

export default function Account({ onDelete }: AccountProps) {
  const accountData = useRecoilValue(accountState);

  return (
    <>
      <div className={styles.account__contents__area}>
        <div className={styles.account__contents}>
          <span className={styles.account__title}>Account</span>

          {accountData != null && (
            <MyProfile
              onDelete={onDelete}
              loginData={accountData}
            />
          )}

          <Billing />
        </div>
      </div>
    </>
  );
}
